import React from "react"
import { SUPER_ADMIN_PAGES } from "helpers/cpAccessPolicy"

export const restrictedPageNames = SUPER_ADMIN_PAGES.map(page => page.label).join(", ")

export const adminPermissions = role => role === "superAdmin"
  ? "Can access all Control Panel sections, including " + restrictedPageNames + ". Can manage administrative accounts while activated."
  : "Cannot manage administrative accounts; these are read-only for Admins. No access to " + restrictedPageNames + "."

export default function AdminRoleGuide() {
  return <section aria-label="Admin and Super admin permissions" className="mt-3 mb-3">
    <p className="mb-2"><strong>Super admin only:</strong> {restrictedPageNames}.</p>
    <details>
      <summary className="text-primary">Compare Admin and Super admin permissions</summary>
      <dl className="mt-3 mb-2">
        <dt>Admin</dt>
        <dd>Can use operational sections such as Users, Clubs, Club Leads and Organizers. Administrative accounts are read-only. Cannot access the sections listed above, export club bookings, delete events, or manually generate or roll back leaderboards.</dd>
        <dt>Super admin</dt>
        <dd>Can access every Control Panel section, including Extended Analytics without an additional password, and perform the additional actions above. Can create, edit, activate, block and delete administrative accounts while their own account is activated.</dd>
      </dl>
      <p className="text-muted mb-0">Both roles require a valid session. Blocked and deleted accounts cannot sign in. Self-blocking, self-deletion, self-demotion and removal of the last activated Super admin are prevented.</p>
    </details>
  </section>
}
